// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-module--icon--1ihz7","spin":"icon-module--spin--1SY71","customMedia":{},"customProperties":{},"customSelectors":{}};